import './Matches.scss';

const Matches = ({ image }) => {
    let matchesStyle = {
        backgroundImage: `url(${image})`,
    };

    return (
        <section
            id="matches"
            className="Matches__showdown"
            style={matchesStyle}
        >
            <div className="container">
                <h2 className="heading heading--medium heading--white text--center">
                    Bekijk wedstrijdoverzicht
                </h2>
                <p className="text text--white text--center">
                    Bekijk hieronder de belangrijke wedstrijden van de
                    Ontknoping.
                </p>
                <div className="matches">
                    <div class="match">
                        <div class="date text text--white">06 juni, 20:00</div>
                        <div class="column text text--white">
                            Almere City FC - FC Emmen
                        </div>
                        <div class="channel text text--white">ESPN 1</div>
                    </div>
                    <div class="match">
                        <div class="date text text--white">08 juni, 20:00</div>
                        <div class="column text text--white">
                            Sparta - FC Twente
                        </div>
                        <div class="channel text text--white">ESPN 1</div>
                    </div>
                    <div class="match">
                        <div class="date text text--white">11 juni, 14:30</div>
                        <div class="column text text--white">
                            FC Twente - Sparta
                        </div>
                        <div class="channel text text--white">ESPN 1</div>
                    </div>
                    <div class="match">
                        <div class="date text text--white">11 juni, 18:30</div>
                        <div class="column text text--white">
                            FC Emmen - Almere City FC
                        </div>
                        <div class="channel text text--white">ESPN 1</div>
                    </div>
                </div>
                <div className="disclaimer text text--white text--center">
                    <p>
                        Heb je een ESPN Compleet abonnement bij een
                        tv-aanbieder? Bekijk via de viedo hieronder hoe je
                        gratis toegang hebt tot de ESPN EXTRA-kanalen.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Matches;
